import React, { useEffect } from "react";
import "./VipHeader.css";
import Common_Back_Btn from "../../Common/Common_Component/common_back_btn/Common_Back_Btn";
import { GETVipLevel } from "../../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";

function VipHeader({ Vip }) {



  return (
    <div className="vip_header">
      <Common_Back_Btn />
      <div className="vip_top">VIP</div>

      <div className="vip_profile">
        <img
          src={IDS.IMG_URL + Vip?.profile_pic}
          // src="https://i.pravatar.cc/100"
          alt="profile"
          className="vip_avatar"
        />
        <div className="vip_user">
          <span className="vip_badge_img_holder">
            {" "}
            <img
              src={IDS.IMG_URL + Vip?.User_Vip?.Vip_Level?.tag_image}
              // src="/assets/images/vip/vip_icons/vip0.webp"
              alt="profile"
              className="vip_badge_img"
            />
          </span>
          <p>{Vip?.user_uid || ""}</p>
          <p>{Vip?.name || ""}</p>
        </div>
      </div>
    </div>
  );
}

export default VipHeader;
